<template>
  <div class="main">
    <div class="wrap-particles">
      <div class="main-content">
        <!-- <b-navbar style="background-color: #fff;">
          <b-navbar-brand>
            <img src="@/assets/logo.png" style="height:40px;">
          </b-navbar-brand>
        </b-navbar> -->

        <div v-if="game" class="container py-4 text-center h-75">
          <h1 class="text-white text-uppercase">{{game.mode}}</h1>

          <div class="row d-flex justify-content-center h-100">
            <form @submit.prevent @submit.prevent.once="join" class="text-white pt-5 w-sm-75 w-md-50 w-lg-25">
              <div class="text-left">
                <div class="form-group">
                  <label>Your name</label>
                  <input v-model="playerName" type="text" class="rounded-0 form-control" minlength="3" maxlength="8" required>
                </div>
                <div class="form-group">
                  <label>Choose your team</label>
                  <div class="row">
                    <div v-for="team in game.teams" :key="team.name" class="col-6">
                      <label>
                        <input name="team" type="radio" v-model="selectedTeam" :value="team.name" required>
                        <img :src="require(`@/assets/team/${team.name}.svg`)" class="w-100 p-2">
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              
              <b-button type="submit" class="mt-auto rounded-0 btn btn-dark text-uppercase">Join</b-button>
            </form>
          </div>
        </div>
      </div>

      <vue-particles color="#ffffff" :particleOpacity="0.3" :particlesNumber="80" shapeType="circle" :particleSize="5"
        :lineLinked="false" :moveSpeed="1" :hoverEffect="false" :clickEffect="false" />
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'gameControl',
  data() {
    return {
      game: null,
      playerName: null,
      selectedTeam: null,
      test: null
    }
  },
  props: ['pin'],
  mounted() {
    let self = this
    firebase.database().ref('games/' + self.pin).once('value').then(function (snapshot) {
      let game = snapshot.val()
      console.log(game)
      if (game && game.state=="waiting") {
        self.game = game
      } else {
        self.$router.replace('/join')
        self.$router.go()
      }
    })
  },
  methods: {
    join: function () {
      let self = this

      let rnd = Math.random().toString(36).substring(3)
      console.log('games/' + self.pin + '/teams/' + self.selectedTeam + '/players/' + rnd)
      firebase.database().ref('games/' + self.pin + '/players/' + rnd).once('value').then(function (snapshot) {
        let isPinExist = (snapshot.val())
        if (!isPinExist) {
          firebase.database().ref('games/' + self.pin + '/players/' + rnd).update({
            uid: rnd,
            name: self.playerName,
            score: 0,
            team: self.selectedTeam
          }).then(function () {
            self.$router.replace('/game/'+self.pin+'/'+rnd)
            self.$router.go()
          }).catch(function (err) {
            console.log(err)
          })
        } else {
          self.create()
        }
      })

      // firebase.database().ref('games/' + self.pin + '/teams/' + self.selectedTeam + '/players').push({
      //   playerName: self.playerName,
      //   score: 0,
      //   team: self.selectedTeam
      // }).catch(function (err) {
      //   console.log(err)
      // })
    }
  }
}
</script>

<style scoped>
.main {
  width: 100vw;
  min-height: 100vh;
  /* overflow: hidden; */
  background-color: #000;
}

/* HIDE RADIO */
[type=radio] { 
  position: absolute;
  opacity: 0;
}

/* IMAGE STYLES */
[type=radio] + img {
  cursor: pointer;
  opacity: 0.4;
  filter: alpha(opacity=40); /* msie */
}

/* CHECKED STYLES */
[type=radio]:checked + img {
  opacity: 1;
  filter: none;
}
</style>

